import { SupplierPalletShipmentGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";

import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../../../hooks/api/v2/apiV2Request";
import { ServerStateKeys } from "../../../hooks/api/v2/ServerStateKeys";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";

export const useSellarDistributionPalletShipment = <
  TData = SupplierPalletShipmentGetResponseType,
>(
  id: number,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      business?.id,
      ServerStateKeys.SellarDistributionPalletShipment,
      id,
    ],

    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `distribution-pallet-shipment/${id}`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: options,
    }),
  });
};
